import * as React from 'react';
import * as classNames from 'classnames';
import './style.css';

export enum ButtonStyle {
  Default = 'default',
  Danger = 'danger'
}

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonStyle?: ButtonStyle;
}

export interface ButtonState {
  /* empty */
}

export class Button extends React.Component<ButtonProps, ButtonState> {
  render() {
    const buttonProps = { ...this.props };

    delete buttonProps.buttonStyle;

    return (
      <button
        {...buttonProps}
        className={classNames(
          'edge-of-play-form-button',
          this.buttonStyleClass(),
          this.props.className
        )}
      >
        {this.props.children}
      </button>
    );
  }

  private buttonStyleClass = () => {
    const { buttonStyle } = this.props;

    if (!buttonStyle) {
      return undefined;
    }

    return `edge-of-play-form-button--${buttonStyle}`;
  };
}

export default Button;



// WEBPACK FOOTER //
// ./src/app/components/Forms/Button/index.tsx